import React, { useState, useEffect, memo } from "react";
import { format } from "date-fns";
import { ru } from "date-fns/locale";

// Libraries
import { m } from "framer-motion";
import { api } from "@/Api/api";

const standardizeTitle = (title) => {
  const MAX_COUNT = 65;

  if (title.length < MAX_COUNT) return title;

  const cuttedTitle = title.substring(0, MAX_COUNT);
  const lastSpaceIndex = cuttedTitle.lastIndexOf(" ");

  return cuttedTitle.substring(0, lastSpaceIndex) + "...";
};

const Show4News = (props) => {
  const [loading, setLoading] = useState(true);
  const [news, setNews] = useState([]);

  useEffect(() => {
    const downloadNews = async () => {
      try {
        const getNews = await api.get("/rss");
        const news = getNews.data.response.news;
        setNews(news);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };
    downloadNews();
  }, []);

  return (
    <div className="grid-wrapper">
      <ul className="flex w-full flex-wrap justify-between">
        {news.map((item, i) => {
          return (
            <li
              key={i}
              className={`w-[calc(25%-30px)] lg:w-[calc(50%-20px)] xs:w-full xs:m-[15px] min-h-[350px] mb-[15px]`}
            >
              <m.div
                className="blog-metro"
                initial={{ opacity: 0 }}
                whileInView={!loading && { opacity: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, ease: "easeOut" }}
                style={{ height: "100%" }}
              >
                <div className="blog-post-image h-full">
                  <img
                    className="w-full h-full object-cover"
                    src={item.enclosures[0].url}
                    alt="blog-post"
                  />
                </div>
                <div className="post-details justify-end">
                  <span className="post-date">
                    {format(item.published, "dd MMMM yyyy", { locale: ru })}
                  </span>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={item.link}
                    className="post-title"
                  >
                    {standardizeTitle(item.title)}
                  </a>
                </div>
              </m.div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default memo(Show4News);
